import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import type { EmbedStepComponent } from 'api/types';
import AgathaMessage from 'components/AgathaMessage/AgathaMessage';
import MessageContainer from 'components/MessageContainer';
import { useAppSelector } from 'hooks';
import type React from 'react';
import { selectIsAuthorIconVisible } from 'reducers/workflows';

interface Props {
  isLastStep: boolean;
  stepIndex: number;
  widgetComponent: EmbedStepComponent;
}

export const EmbedStep: React.FC<React.PropsWithChildren<Props>> = ({
  stepIndex,
  widgetComponent,
}) => {
  const theme = useTheme();
  const isAuthorIconVisible = useAppSelector(state =>
    selectIsAuthorIconVisible(state, stepIndex),
  );

  return (
    <MessageContainer>
      <StyledAgathaMessage
        isAuthorIconVisible={isAuthorIconVisible}
        stepIndex={stepIndex}
      >
        {/* iframe is 16:9 responsive */}
        <Box
          sx={{
            aspectRatio: '16 / 9',
          }}
        >
          <Box
            allowFullScreen
            component='iframe'
            name='Forethought Embed Step'
            referrerPolicy='strict-origin-when-cross-origin'
            src={widgetComponent.component_fields.embed_url}
            sx={{
              border: `1px solid ${theme.palette.colors.slate[200]}`,
              borderRadius: '8px',
              height: '100%',
              width: '100%',
            }}
            title='Forethought Embed Step'
          />
        </Box>
      </StyledAgathaMessage>
    </MessageContainer>
  );
};

const StyledAgathaMessage = styled(AgathaMessage)`
  padding: 0px;
  background-color: transparent;
  margin-right: 0px;
  width: calc(100% - 24px);
`;
